/**
 * Returns the translated display names for the fixed system folders in the project bank.
 * @param {Function} t - i18next translation function (namespace 'common')
 * @returns {Object} map of raw folder name → translated label
 */
export const getSystemFolderNames = (t) => ({
  documents: t('file.documents'),
  images: t('file.images'),
  forms: t('forms.forms'),
  reports: t('file.reports'),
  'videochat-recordings': t('file.recordings'),
});

/**
 * Returns the display label for a folder or file-permission item in the project bank.
 * Handles business-root folders, project-key folders and all system folders.
 * @param {Object} folder - folder or file permission object
 * @param {Function} t - i18next translation function (namespace 'common')
 * @returns {string}
 */
export const getFolderDisplayName = (folder, t) => {
  if (folder.translationKey) {
    const key = folder.translationKey.includes('.')
      ? folder.translationKey
      : `bank.translated_items.${folder.translationKey}`;
    const translated = t(key);
    if (translated !== key) return translated;
    return folder.name;
  }
  if (folder.name === folder.businessId) return folder.name;
  if (folder?.project?.projectKey === folder.name)
    return `${folder.project.name} (${folder.project.projectKey})`;
  const systemFolderNames = getSystemFolderNames(t);
  if (systemFolderNames[folder.name]) return systemFolderNames[folder.name];
  return folder.name;
};
